import _ from "lodash"
import useFetchStatus from "customHooks/useFetchStatus"
import moment from "moment"
let db = window.firebaseFirestore

/**
 * update a document at firebase
 *
 * @param {object} data     - document fields
 * @param {string} docPath  - doc path in the firestore
 */
export let updateDoc = async (data, docPath) => {

    let db = window.firebaseFirestore
    let ref = db.doc(docPath)


    await ref.set(data, { merge: true })

}


/**
 * handle inprogress tickets to filter the tasks of the current staff
 * @param {array} inprogressTickets
 * @param {string} currentStaff
 * 
 * @return {array} filteredTickets
 */
 // step 1 : inprogress tickets
    // step 2 : check staffIds in getway (getwayIds)
    // step 3 : compare with requested staff supervisor&manager (supervisorIds)
    // step 4 : check if the staff before the current is include in abbroved list & filter them
export let getGetways = async (inprogressTickets , currentStaff) => {
    let filteredTickets = []

    _.forEach(inprogressTickets, async (ticket) => {

        let getwaysList = [], supervisorsList = []

        // get the request form getway staffs
       let getways = await fetchData('gateway', 'formId', ticket.formId)
       getwaysList = getways.staffs
    
       // get satff manger & supervisors list
       let supervisors = await fetchData('staff', 'id', ticket.requestedBy)
       let {manager , supervisor} = supervisors
       
       supervisorsList = !_.isEmpty(supervisor)?  [manager , ...supervisor] : [manager]

       // map the getways with staff supervisorList 
        let getwayIds = [] // the mapped getwayIds
        if (!_.isEmpty(getwaysList)) {
            _.map(getwaysList, (getway) => {

                if (getway === "manager")
                    getwayIds = [...getwayIds, manager]
                else if (getway === "supervisor")
                    getwayIds = !_.isEmpty(supervisor)? [...getwayIds, ...supervisor] : [...getwayIds]
                else
                    getwayIds = [...getwayIds, getway]
            })

        }

        // add the getwaysIds to the ticket (need for actions to know if this staff is the last one )
        ticket.getwayIds = getwayIds

        //ckeck if the ticket is staff task 
        let task = await checkTickets(ticket, /*getwayIds,*/ currentStaff)
        console.log(task)

        // push to the filtered tickets
        if(!_.isEmpty(task)) filteredTickets = [...filteredTickets, task]
        console.log(filteredTickets)


    })
    console.log(filteredTickets)
    return filteredTickets

}

/**
 * ckeck if the ticket is staff task 
 * @param {object} ticket
 * @param {array} getwayIds
 * @param {string} currentStaff
 * 
 * @return {object} of staff task
 */
export let checkTickets = (ticket, /*getwayIds,*/ currentStaff) => {
    let task
    console.log({ ticket/*, getwayIds*/ })
    let { approvedBy, getwayIds, directedStaffs } = ticket
    let approves = _.orderBy(approvedBy, info => info.date)
    console.log(getwayIds)
    let getways = !_.isEmpty(directedStaffs)? directedStaffs : getwayIds

    // if no one approve the ticket yet , check if this staff is the first in the getwaysIds
    if (_.isEmpty(approves)) {
        if (!_.isEmpty(getways) &&_.head(getways) === currentStaff)
            task = ticket
    }

    //find the last one who approve the ticket to know if the current staff is the next one  or not 
    else {
        //if (!_.isEmpty(getways)) {

        if (!_.isEmpty(directedStaffs) && _.head(directedStaffs) === currentStaff)
            task = ticket

        else {
            approves = _.filter(approves , approve => approve.directed == false)
            let approvedIds = _.map(approves, approve => approve.id)
            let lastApproved = approvedIds[approvedIds.length - 1] // to find last approved
            let lastApprovedIndx = _.indexOf(getways, lastApproved)

            if (getways[lastApprovedIndx + 1] == currentStaff)
                task = ticket
        }
       // }

    }

    console.log(task)

    return task

}

export let fetchData = async (url, field = null, value = null) => {

    let result = {} ; let ref 

    if (!_.isEmpty(field) && !_.isEmpty(value)) {

        ref = db.collection(url).where(field, '==', value)

        await ref.get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                let data = doc.data()
                let id = doc.id
                result = { ...data, id }
            })
        })
    }
      
    else {
        ref = db.doc(url)

        await ref.get().then((doc) => {
            let data = doc.data()
            let id = doc.id
            result = { ...data, id }
        })

    }

    return result
}

export async function getTicketStep2(tickets, staffs) {

    await Promise.all(_.map(tickets, async (ticket) => {

        // get approved staff
        let approves = _.orderBy(ticket.approvedBy, info => info.date)

        if (ticket.isApproved == true)
            ticket.step = "Approved"
        else if (!ticket.inProgress && !ticket.isApproved & !ticket.wasCanceled && !ticket.isCompleted)
            ticket.step = "Declined"
        else if (ticket.wasCanceled == true)
            ticket.step = "Canceled"
        else if (!ticket.inProgress && ticket.isCompleted)
            ticket.step = "Completed"
        else {
            // if no one approve yet
            if (_.isEmpty(approves) || _.isEmpty( _.last(_.filter(approves, approve => approve.directed == false)))) {
                let currentStep = !_.isEmpty(ticket.directedStaffs)? _.head(ticket.directedStaffs) : _.head(ticket.getwayIds)
                let approveNeed = _.find(staffs, staff => staff.id === currentStep)

                ticket.step = approveNeed ? approveNeed.name_en : ''
            }
            else {
                let lastApproved = _.last(_.filter(approves, approve => approve.directed == false))
                let lastApprovedIndx = _.indexOf(ticket.getwayIds, lastApproved.id)
                let currentStep = !_.isEmpty(ticket.directedStaffs) ? _.head(ticket.directedStaffs) : ticket.getwayIds[lastApprovedIndx + 1]
                if (currentStep) {
                    let approveNeed = _.find(staffs, staff => staff.id === currentStep)
                    ticket.step = approveNeed ? approveNeed.name_en : ''

                }
                else
                    ticket.step = 'Deleted Staff'

            }

        }
    }))

    return tickets

}


// this function to add gewaysIds of each ticket which need to know in which step the ticket is

export let handleTicket = async (ticket, isNewTicket = false ) => {

    let getwaysList = [], supervisorsList = []

    // get the request form getway staffs
    let getways = await fetchData('gateway', 'formId', ticket.formId)
    getwaysList = getways.staffs

    // get satff manger & supervisors list
    let supervisors = await fetchData(`staff/${ticket.requestedBy}`)
    let { manager, supervisor } = supervisors

    supervisorsList = !_.isEmpty(supervisor) ? [manager, ...supervisor] : [manager]

    // map the getways with staff supervisorList 
    let getwayIds = [] // the mapped getwayIds
    if (!_.isEmpty(getwaysList)) {
        _.map(getwaysList, (getway) => {

            if (getway === "manager")
                getwayIds = manager? [...getwayIds, manager] : [...getwayIds]
            else if (getway === "supervisor")
                getwayIds = !_.isEmpty(supervisor) ? [...getwayIds, ...supervisor] : [...getwayIds]
            else
                getwayIds = getway? [...getwayIds, getway] : [...getwayIds]
        })

    }

    // add the getwaysIds to the ticket (need for actions to know if this staff is the last one )
    ticket.getwayIds = getwayIds

    if (!isNewTicket)
        ticket.date = !_.isEmpty(ticket.approvedBy)? _.last(_.values(ticket.approvedBy)).date : moment(ticket.openedAt.toDate())

     return ticket
    
}

export function addDate (ticket) {

    ticket.date = !_.isEmpty(ticket.approvedBy) ? _.last(_.values(ticket.approvedBy)).date : moment(ticket.openedAt.toDate())

    return ticket
}

export async function getTicketStep(ticket, staffs) {

    // get approved staff
    let approves = _.orderBy(ticket.approvedBy, info => info.date)

    if (ticket.isApproved == true)
        ticket.step = "Approved"
    else if (!ticket.inProgress && !ticket.isApproved & !ticket.wasCanceled && !ticket.isCompleted)
        ticket.step = "Declined"
    else if (ticket.wasCanceled == true)
        ticket.step = "Canceled"
    else if (!ticket.inProgress && ticket.isCompleted)
        ticket.step = "Completed"
    else {
        // if no one approve yet
        if (_.isEmpty(approves) || _.isEmpty(_.last(_.filter(approves, approve => approve.directed == false)))) {
            let currentStep = !_.isEmpty(ticket.directedStaffs) ? _.head(ticket.directedStaffs) : _.head(ticket.getwayIds)
            let approveNeed = _.find(staffs, staff => staff.id === currentStep)

            ticket.step = approveNeed ? approveNeed.name_en : ''
        }
        else {
            let lastApproved = _.last(_.filter(approves, approve => approve.directed == false))
            let lastApprovedIndx = _.indexOf(ticket.getwayIds, lastApproved.id)
            let currentStep = !_.isEmpty(ticket.directedStaffs) ? _.head(ticket.directedStaffs) : ticket.getwayIds[lastApprovedIndx + 1]
            if (currentStep) {
                let approveNeed = _.find(staffs, staff => staff.id === currentStep)
                ticket.step = approveNeed ? approveNeed.name_en : ''

            }
            else
                ticket.step = 'Deleted Staff'

        }

    }

}


export let mappingStaffs = async (ticket, redirectedStaffs) => {

    // get satff manger & supervisors list
    let supervisors = await fetchData(`staff/${ticket.requestedBy}`)
    let { manager, supervisor } = supervisors

    // map the getways with staff supervisorList 
    let staffIds = [] // the mapped staffIds
    _.map(redirectedStaffs, (getway) => {

        if (getway === "manager")
            staffIds = manager ? [...staffIds, manager] : [...staffIds]
        else if (getway === "supervisor")
            staffIds = !_.isEmpty(supervisor) ? [...staffIds, ...supervisor] : [...staffIds]
        else
            staffIds = getway ? [...staffIds, getway] : [...staffIds]
    })

    return staffIds

}

